import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';

Swiper.use([Autoplay, Navigation, Pagination]);

export default class Home {
    constructor() {
        if (document.getElementById('home') !== null) {
            this.initSocial();
            this.initBanners();
            this.initPropertySlider();
        }
    }

    initSocial() {
        new Swiper('#social .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 5,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                }
            }
        });
    }

    initBanners() {
        new Swiper('#banners .swiper-container', {
            slidesPerView: 1,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }

    initPropertySlider() {
        new Swiper('#propertySlider .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                }
            }
        });
    }
}
